import React from 'react';
import styled, { css } from 'styled-components';
import { Flex, Box } from 'rebass';
import { Controller, Scene } from 'react-scrollmagic';

import WideContainer from '../../components/WideContainer/WideContainer';
import Button from '../../components/Button/Button';
import NewsArticleCard from '../../components/NewsArticleCard/NewsArticleCard';
import OldArticleCard from '../../components/NewsArticleCard/OldArticleCard';
import Typography from '../../components/Typography/Typography';

import { theme } from '../../styles/theme';
import parseNews from '../../utils/parseNews';
import isFadeEnabled from '../../utils/isFadeEnabled';
import { useStaticQuery, graphql } from 'gatsby';
import { NewsSummarySectionStoryblok } from '../../types/storyblok';

const NewsArticleBox = styled(Box)`
  ${(props) =>
    props.border &&
    css`
      @media (min-width: ${theme.breakpoint.md}) {
        border-right: 1px solid ${theme.colors.darkGrey};

        :last-child {
          border-right: 0;
        }
      }
    `}
`;

const NewsSummarySection = ({
  title,
  buttonText,
  buttonUrl,
  newCards,
}: NewsSummarySectionStoryblok) => {
  const data = useStaticQuery(graphql`
    query {
      stories: allStoryblokEntry(
        filter: {
          first_published_at: { ne: null }
          field_title_string: { ne: null }
          field_component: { in: ["NewsItem", "page"] }
          full_slug: { regex: "/^articles//" }
        }
        sort: { field_datePublished_string: DESC }
        limit: 3
      ) {
        nodes {
          field_component
          field_title_string
          field_description_string
          field_category_string
          field_datePublished_string
          field_link_string
          field_quote_string
          full_slug
          uuid
        }
      }
    }
  `);
  return (
    <Box as="section" px={4} py={[8, 9, 10]}>
      <Controller globalSceneOptions={{ triggerHook: 'onEnter' }}>
        <Scene classToggle="full-opacity">
          <WideContainer className={isFadeEnabled() ? 'zero-opacity' : ''}>
            {title && (
              <Box pb={[5, 4, 8]}>
                <Typography component="h2" textAlign="center" mx="auto">
                  {title}
                </Typography>
              </Box>
            )}
            <Flex flexWrap="wrap" mx={[-2, -3, -4]}>
              {data?.stories?.nodes?.length > 0 ? (
                data.stories.nodes
                  .filter((item) => item && typeof item === 'object')
                  .map((article) => {
                    const { uid: key, ...newsMeta } = parseNews(article);
                    return (
                      <NewsArticleBox
                        {...(!newCards ? { border: true } : {})}
                        key={key}
                        width={[1, 1 / 1, 1 / 3]}
                        mb={[5, , 5]}
                      >
                        {newCards ? (
                          <NewsArticleCard {...newsMeta} />
                        ) : (
                          <OldArticleCard {...newsMeta} />
                        )}
                      </NewsArticleBox>
                    );
                  })
              ) : (
                <Typography textAlign="center" width={1}>
                  No news articles selected
                </Typography>
              )}
            </Flex>
            {buttonText && (
              <Box marginTop={[0, 3, 8]} textAlign="center">
                <Button href={buttonUrl} arrow>
                  {buttonText}
                </Button>
              </Box>
            )}
          </WideContainer>
        </Scene>
      </Controller>
    </Box>
  );
};

export default NewsSummarySection;
